module.exports = __webpack_public_path__ + "img/section4-index.72784aea.png";